module.exports = __webpack_public_path__ + "img/saum_ultramarinblau_ral5002.63236132.jpg";